import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const FEATURED_IMAGE = "https://customer-assets.emergentagent.com/job_67b9bb81-7260-44ec-aaa3-ea9719c1ace2/artifacts/civww0ec_c2de06ca-2f26-4c7f-a997-2f07da68243b.jpeg";

export const Featured = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#kontakt');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section
      className="py-24 lg:py-32 bg-slate-900 overflow-hidden"
      data-testid="featured-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <span className="inline-block px-4 py-1.5 bg-teal-600/20 text-teal-400 text-sm font-semibold rounded-full mb-6">
              PROFESSIONELLES DESIGN
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-6">
              Sichtbarkeit, die wirkt
            </h2>
            <p className="text-lg text-slate-300 mb-8 leading-relaxed">
              Vom kreativen Konzept bis zur druckfertigen Folie – wir gestalten professionelle Werbetechnik, die Ihre Marke ins beste Licht rückt.
            </p>
            <ul className="space-y-4 mb-10">
              <li className="flex items-center gap-3 text-slate-300">
                <div className="w-2 h-2 bg-teal-400 rounded-full" />
                Individuelle Designs nach Ihren Wünschen
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <div className="w-2 h-2 bg-teal-400 rounded-full" />
                Hochwertige Folien für Eigenanwendung
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <div className="w-2 h-2 bg-teal-400 rounded-full" />
                Versandfertig zu Ihnen geliefert
              </li>
            </ul>
            <Button
              onClick={scrollToContact}
              className="bg-teal-500 hover:bg-teal-400 text-slate-900 rounded-full px-8 py-6 text-base font-semibold shadow-lg transition-all"
              data-testid="featured-cta"
            >
              Design anfragen
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={FEATURED_IMAGE}
                alt="MS-Galabau Fahrzeugbeschriftung"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-teal-600 rounded-2xl -z-10 hidden lg:block" />
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-teal-500/30 rounded-2xl -z-10 hidden lg:block" />
          </div>
        </div>
      </div>
    </section>
  );
};
